module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-stone-path-remnants.63a7fa1b.png";